import { CheckCircle2, Clock, AlertTriangle, CircleDashed } from "lucide-react";
import { cn } from "@/lib/utils";

// Status = colour + icon + text (never colour alone). Brand orange is NOT used for status.
const MAP = {
  ok: { label: "OK", cls: "status-ok", Icon: CheckCircle2 },
  upcoming: { label: "Nærmar seg", cls: "status-upcoming", Icon: Clock },
  overdue: { label: "Forfalt", cls: "status-overdue", Icon: AlertTriangle },
  none: { label: "Ikkje sett", cls: "bg-muted text-muted-foreground border-border", Icon: CircleDashed },
};

export const StatusPill = ({ status, label, size = "sm", className, testid }) => {
  const m = MAP[status] || MAP.none;
  const Icon = m.Icon;
  return (
    <span
      data-testid={testid || `status-pill-${status || "none"}`}
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap",
        size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm",
        m.cls,
        className
      )}
    >
      <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {label || m.label}
    </span>
  );
};

/** Small dot for calendars/lists */
export const StatusDot = ({ status, className }) => (
  <span
    className={cn(
      "inline-block h-2.5 w-2.5 rounded-full",
      status === "overdue" && "bg-[rgb(var(--status-overdue))]",
      status === "upcoming" && "bg-[rgb(var(--status-warn))]",
      status === "ok" && "bg-[rgb(var(--status-ok))]",
      !status && "bg-muted-foreground/40",
      className
    )}
  />
);
